import type { IconSvgObject } from './types';

const Female02Icon: IconSvgObject = [
  ["path", { d: "M14.5001 16.5L18.9853 17.6213C19.8756 17.8439 20.5002 18.6438 20.5002 19.5616V21.5H3.50024L3.55348 19.5125C3.57745 18.6177 4.19295 17.8479 5.06045 17.6276L9.5001 16.5V14.345C8.21532 14.1822 7.03049 13.897 6.0001 13.5161C6.5001 12.5322 7.0001 11.0563 7.0001 7.61264C7.0001 1.70919 12.5001 1.70912 14.0001 3.67672C17.0001 3.18499 17.0001 5.64483 17.0001 8.59655C17.0001 10.9579 17.6668 12.8602 18.0001 13.5161C16.9697 13.897 15.7849 14.1822 14.5001 14.345V16.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Female02Icon;
